import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToSection } from "../../../components/SectionLink.tsx";

/**
 * Scrolls to the section named by `location.hash` after the homepage has mounted.
 *
 * Used for cross-page section links (e.g. "Host an Event" tapped on an event page navigates to
 * "/#host"): by the time this runs the target section exists in the layout, so the scroll lands
 * correctly instead of at the top. Deferred a frame so it wins over <ScrollRestoration>'s reset.
 */
export function useScrollToHash(): void {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const raf = requestAnimationFrame(() => scrollToSection(id));
    return () => cancelAnimationFrame(raf);
  }, [hash]);
}
